
export function getQuarterStartEndDates(quarterNumber: number, year: number) {
    let startDate: Date;
    let endDate: Date;

    switch(quarterNumber) {
        case 1:
            startDate = new Date(`${year}-01-01`);
            endDate = new Date(`${year}-03-31`);
            break;
        case 2: 
            startDate = new Date(`${year}-04-01`);
            endDate = new Date(`${year}-06-30`); 
            break;
        case 3: 
            startDate = new Date(`${year}-07-01`);
            endDate = new Date(`${year}-09-30`); 
            break;
        case 4: 
            startDate = new Date(`${year}-10-01`);
            endDate = new Date(`${year}-12-31`); 
            break;
        default: throw `Invalid quarter ${quarterNumber}`;
    }

    return {
        startDate: new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate()),
        endDate: new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate())
    };
} 